// Datos completos de las chicas con todos los atributos para filtrado
export const chicasData = [
  {
    id: 1,
    nombre: "Sofía Ramírez",
    edad: 19,
    distrito: "Miraflores",
    distritosDisponibles: ["Miraflores", "San Isidro"],
    imagen: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop",
    tags: ["Nueva", "Popular"],
    tipos: ["gotica", "otaku"],
    tarifaHora: 150,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654321",
    descripcion: "Me encanta el anime y la cultura gótica"
  },
  {
    id: 2,
    nombre: "Valentina Torres",
    edad: 24,
    distrito: "San Isidro",
    distritosDisponibles: ["San Isidro", "Miraflores", "Barranco"],
    imagen: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=600&fit=crop",
    tags: ["Popular", "Ranking 3°"],
    tipos: ["cosplayer", "otaku"],
    tarifaHora: 200,
    horasMinimas: 3,
    horasMaximas: 10,
    telefono: "987654322",
    descripcion: "Cosplayer profesional y amante del anime"
  },
  {
    id: 3,
    nombre: "Isabella García",
    edad: 22,
    distrito: "Barranco",
    distritosDisponibles: ["Barranco", "Miraflores"],
    imagen: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=600&fit=crop",
    tags: ["Nueva"],
    tipos: ["gamer", "otaku"],
    tarifaHora: 180,
    horasMinimas: 2,
    horasMaximas: 6,
    telefono: "987654323",
    descripcion: "Gamer apasionada y streamer"
  },
  {
    id: 4,
    nombre: "Camila Flores",
    edad: 25,
    distrito: "Surco",
    distritosDisponibles: ["Surco", "San Borja"],
    imagen: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["adorable", "timida"],
    tarifaHora: 160,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654324",
    descripcion: "Dulce y encantadora"
  },
  {
    id: 5,
    nombre: "María López",
    edad: 27,
    distrito: "Lince",
    distritosDisponibles: ["Lince", "Jesús María", "San Miguel"],
    imagen: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop",
    tags: ["Ranking 1°", "Popular"],
    tipos: ["fitness", "extrovertida"],
    tarifaHora: 250,
    horasMinimas: 3,
    horasMaximas: 12,
    telefono: "987654325",
    descripcion: "Entrenadora personal y amante del fitness"
  },
  {
    id: 6,
    nombre: "Lucía Mendoza",
    edad: 26,
    distrito: "San Borja",
    distritosDisponibles: ["San Borja", "Surco", "Surquillo"],
    imagen: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=600&fit=crop",
    tags: ["Popular", "Ranking 6°"],
    tipos: ["cinefila", "extrovertida"],
    tarifaHora: 190,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654326",
    descripcion: "Amante del cine y las artes"
  },
  {
    id: 7,
    nombre: "Ana Martínez",
    edad: 21,
    distrito: "Pueblo Libre",
    distritosDisponibles: ["Pueblo Libre", "Jesús María", "Magdalena"],
    imagen: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop",
    tags: ["Nueva"],
    tipos: ["adorable", "otaku"],
    tarifaHora: 150,
    horasMinimas: 2,
    horasMaximas: 6,
    telefono: "987654327",
    descripcion: "Kawaii y fan del anime"
  },
  {
    id: 8,
    nombre: "Paula Sánchez",
    edad: 20,
    distrito: "Magdalena",
    distritosDisponibles: ["Magdalena", "Pueblo Libre", "San Miguel"],
    imagen: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=600&fit=crop",
    tags: ["Nueva", "Ranking 10°"],
    tipos: ["gamer", "cosplayer"],
    tarifaHora: 170,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654328",
    descripcion: "Gamer y cosplayer en eventos"
  },
  {
    id: 9,
    nombre: "Carolina Díaz",
    edad: 23,
    distrito: "Lince",
    distritosDisponibles: ["Lince", "Jesús María"],
    imagen: "https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["gotica", "cinefila"],
    tarifaHora: 180,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654329",
    descripcion: "Gótica elegante amante del cine"
  },
  {
    id: 10,
    nombre: "Andrea Vargas",
    edad: 28,
    distrito: "San Isidro",
    distritosDisponibles: ["San Isidro", "Miraflores", "San Borja"],
    imagen: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["milf", "fitness"],
    tarifaHora: 300,
    horasMinimas: 3,
    horasMaximas: 12,
    telefono: "987654330",
    descripcion: "Madura y sofisticada"
  },
  {
    id: 11,
    nombre: "Daniela Cruz",
    edad: 22,
    distrito: "Jesús María",
    distritosDisponibles: ["Jesús María", "Lince", "Pueblo Libre"],
    imagen: "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?w=400&h=600&fit=crop",
    tags: ["Nueva"],
    tipos: ["timida", "adorable"],
    tarifaHora: 140,
    horasMinimas: 2,
    horasMaximas: 6,
    telefono: "987654331",
    descripcion: "Tímida pero encantadora"
  },
  {
    id: 12,
    nombre: "Gabriela Rojas",
    edad: 25,
    distrito: "Miraflores",
    distritosDisponibles: ["Miraflores", "Barranco", "San Isidro"],
    imagen: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["extrovertida", "gamer"],
    tarifaHora: 180,
    horasMinimas: 2,
    horasMaximas: 8,
    telefono: "987654332",
    descripcion: "Extrovertida y divertida"
  },
  {
    id: 13,
    nombre: "Fernanda Silva",
    edad: 24,
    distrito: "Barranco",
    distritosDisponibles: ["Barranco", "Miraflores", "Surquillo"],
    imagen: "https://images.unsplash.com/photo-1513956589380-bad6acb9b9d4?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["gotica", "cosplayer"],
    tarifaHora: 200,
    horasMinimas: 3,
    horasMaximas: 10,
    telefono: "987654333",
    descripcion: "Gótica y cosplayer creativa"
  },
  {
    id: 14,
    nombre: "Natalia Herrera",
    edad: 26,
    distrito: "Surco",
    distritosDisponibles: ["Surco", "San Borja", "Surquillo"],
    imagen: "https://images.unsplash.com/photo-1515191107209-c28698631303?w=400&h=600&fit=crop",
    tags: ["Ranking 5°"],
    tipos: ["fitness", "extrovertida"],
    tarifaHora: 220,
    horasMinimas: 3,
    horasMaximas: 10,
    telefono: "987654334",
    descripcion: "Atleta y motivadora"
  },
  {
    id: 15,
    nombre: "Victoria Morales",
    edad: 29,
    distrito: "San Miguel",
    distritosDisponibles: ["San Miguel", "Pueblo Libre", "Magdalena"],
    imagen: "https://images.unsplash.com/photo-1516575150278-77136aed6920?w=400&h=600&fit=crop",
    tags: ["Popular"],
    tipos: ["milf", "cinefila"],
    tarifaHora: 280,
    horasMinimas: 3,
    horasMaximas: 12,
    telefono: "987654335",
    descripcion: "Elegante y cultured"
  }
];

export const distritos = [
  "Todos",
  "Miraflores",
  "Lince",
  "Jesús María",
  "San Miguel",
  "San Isidro",
  "Pueblo Libre",
  "Barranco",
  "Magdalena",
  "Surco",
  "Surquillo",
  "San Borja"
];

export const tipos = [
  { id: "gotica", nombre: "Gótica" },
  { id: "cosplayer", nombre: "Cosplayer" },
  { id: "otaku", nombre: "Otaku" },
  { id: "gamer", nombre: "Gamer" },
  { id: "adorable", nombre: "Adorable" },
  { id: "fitness", nombre: "Fitness" },
  { id: "cinefila", nombre: "Cinéfila" },
  { id: "milf", nombre: "Milf" },
  { id: "extrovertida", nombre: "Extrovertida" },
  { id: "timida", nombre: "Tímida" }
];